import {ArrowRight, Flame, Sparkles} from 'lucide-react'

const AFFILIATE_URL = "https://7a443-dowj3abigeyaweye61wj.hop.clickbank.net"

export default function AffiliateBanner() {
  return (
    <section
      aria-label="Sponsored partner offer"
      className="relative bg-white pt-0 pb-0 px-4 sm:px-6"
    >
      <div className="max-w-6xl mx-auto pt-6 pb-2">
        <a
          href={AFFILIATE_URL}
          target="_blank"
          rel="sponsored noopener noreferrer"
          className="group relative block overflow-hidden rounded-2xl border border-emerald-100 bg-gradient-to-r from-slate-800 via-slate-700 to-emerald-700 shadow-lg hover:shadow-emerald-500/20 transition-all duration-300 hover:-translate-y-0.5"
        >
          {/* Decorative glow */}
          <div className="absolute -top-20 -right-20 w-72 h-72 bg-emerald-400/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-20 -left-10 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" />

          {/* Subtle grid pattern */}
          <div
            className="absolute inset-0 opacity-[0.07] pointer-events-none"
            style={{
              backgroundImage:
                "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
              backgroundSize: "32px 32px",
            }}
          />

          <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5 p-5 sm:p-6 lg:p-7">
            {/* Left: Icon + Text */}
            <div className="flex items-start sm:items-center gap-4 flex-1">
              <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-emerald-500/20 border border-emerald-400/40 flex items-center justify-center backdrop-blur-sm">
                <Flame className="w-6 h-6 sm:w-7 sm:h-7 text-emerald-300" />
              </div>

              <div className="flex-1 min-w-0">
                <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-emerald-500/15 border border-emerald-400/30 mb-1.5">
                  <Sparkles className="w-3 h-3 text-emerald-300" />
                  <span className="text-[10px] font-bold tracking-wider uppercase text-emerald-300">
                    Sponsored
                  </span>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-white leading-tight">
                  Boost Your Fat Loss Results — Recommended Partner Program
                </h3>
                <p className="text-xs sm:text-sm text-emerald-100/80 mt-1 leading-relaxed">
                  Pair your calculated macros with a science-backed plan trusted by thousands.
                </p>
              </div>
            </div>

            {/* Right: CTA */}
            <div className="flex-shrink-0 w-full sm:w-auto">
              <span className="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-5 py-3 bg-emerald-500 text-white font-semibold rounded-xl group-hover:bg-emerald-400 transition-all shadow-md text-sm sm:text-base">
                Learn More
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </div>
        </a>

        {/* Disclosure */}
        <p className="text-[11px] text-slate-400 text-center mt-3 px-2">
          Affiliate disclosure: We may earn a commission at no extra cost to you.
        </p>
      </div>
    </section>
  )
}
